import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import styles from './InfoTable.module.scss'

const commonPropTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

const InfoTable = ({ children, className }) => (
  <table className={cx(styles.table, className)}>
    {children}
  </table>
)

const InfoTableHeader = ({ children, className }) => <tr className={cx(styles.header, className)}>{children}</tr>
const InfoTableShadedCell = (
  { children, className },
) => <td className={cx(styles.shadedCell, className)}>{children}</td>

InfoTable.Header = InfoTableHeader
InfoTable.ShadedCell = InfoTableShadedCell

InfoTable.propTypes = {
  ...commonPropTypes,
}

InfoTableHeader.propTypes = {
  ...commonPropTypes,
}

InfoTableShadedCell.propTypes = {
  ...commonPropTypes,
}

export default InfoTable
